import { OnInit, EventEmitter } from '@angular/core';
var NotificationTypeActionComponent = /** @class */ (function () {
    function NotificationTypeActionComponent() {
        this.onActionTriggered = new EventEmitter();
    }
    NotificationTypeActionComponent.prototype.ngOnInit = function () {
    };
    NotificationTypeActionComponent.prototype.actionTriggered = function () {
        this.onActionTriggered.emit();
    };
    NotificationTypeActionComponent.prototype.getLinkId = function (displayText) {
        return displayText.toLowerCase().replace(/ /g, "-") + "-link-notificaciones";
    };
    return NotificationTypeActionComponent;
}());
export { NotificationTypeActionComponent };
